import { FunctionComponent } from 'react'
import NextImage from 'next/image'
import { WTag, WTitle } from '@alice-health/wonderland-react'

interface ProviderDrawerTitleProps {
  title: string
  image: string
  tags?: string[]
}

/*
 * Cabecalho dos dois drawers de detalhe (nodes 26:40868 e 26:41637). Nao existe
 * mais capa: a imagem e um quadrado de 80px com raio `sm`, e o nome mais as
 * tags ficam ao lado dela.
 */
const ProviderDrawerTitle: FunctionComponent<ProviderDrawerTitleProps> = ({
  title,
  image,
  tags
}) => {
  return (
    <div className='mb-gl-spacing-06 flex items-center gap-gl-spacing-06 px-gl-spacing-06 lg:px-0'>
      <div className='relative h-[72px] w-[72px] shrink-0 overflow-hidden rounded-gl-border-radius-sm lg:h-20 lg:w-20'>
        <NextImage
          src={image}
          alt='Imagem do prestador'
          fill
          className='object-cover'
          sizes='80px'
          priority
        />
      </div>

      {/* `min-w-0`: sem isso um titulo longo nao quebra e alarga o painel. */}
      <div className='flex min-w-0 flex-col gap-gl-spacing-03'>
        <WTitle size='medium'>{title}</WTitle>

        {tags?.length ? (
          <div className='tag-pill-theme flex flex-wrap items-center gap-gl-spacing-02'>
            {tags.map(tag => (
              <WTag
                key={tag}
                label={tag}
                color='gray'
                size='small'
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export type { ProviderDrawerTitleProps }

export { ProviderDrawerTitle }
